var History = require('backbone-torso/modules/history');
var sessionStorageService = require('./../../../storage/sessionStorageService');
var EregAuthErrorView = require('./EregAuthErrorView');

var SERIAL_NUMBER_PROPERTY_NAME = sessionStorageService.SESSION_STORAGE_KEYS.serialNumber;

/**
 * Error View for Invalid Security Question Responses
 *
 * @class SecurityQuestionResponseInvalidErrorView
 * @constructor
 */
module.exports = EregAuthErrorView.extend({
  errorMessageKey: 'eregAuth.error.SecurityQuestionResponseInvalid.message.final',

  /**
   * @method initialize
   * @override
   * @param options {Object} configuration for this view
   *   @param options.tryAgain {Boolean} Flag to know if this view should show it's Try Again button or not
   */
  initialize: function(options) {
    var tryAgain = (options && options.tryAgain) || false;

    // For this Error there exists a state which you can try again from, requiring two buttons and nav functions
    if (tryAgain) {
      this.errorMessageKey = 'eregAuth.error.SecurityQuestionResponseInvalid.message.retry';
      this.buttonOneMessageKey = 'eregAuth.error.button.tryAgain';
      this.buttonOneNavFunction = this.retrySecurityQuestion;
      this.buttonTwoMessageKey = 'eregAuth.error.button.exit';
      this.buttonTwoNavFunction = function() {
        History.navigate('tablet/serialNumber/' + sessionStorageService.getItem(SERIAL_NUMBER_PROPERTY_NAME), {trigger: true});
      };
    }

    EregAuthErrorView.prototype.initialize.apply(this, options);

    this.listenTo(this.viewState, 'change:canTryAgain', this.render);
  },

  /**
   * Triggers a retryBarcode event for the parent view to listen to
   * and disposes itself
   */
  retrySecurityQuestion: function() {
    this.trigger('retrySecurityQuestion');
  }
});
